import { useNotification } from 'components/Notification'
import { useAffiliate } from 'hooks/useAffiliate'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { Teammate } from 'types'
import * as affiliatesService from 'services/affiliates'

type Props = {
  onClose: () => void
  teammate: Teammate
}

export function useRemoveTeammate({ onClose, teammate }: Props) {
  const { id } = teammate
  const { selectedAffiliate: affiliate } = useAffiliate()
  const form = useForm()
  const queryClient = useQueryClient()
  const showNotification = useNotification()

  const removeTeammate = useMutation(() =>
    affiliatesService.removeTeammate({
      userId: id,
      affiliateId: affiliate?.id,
    }),
  )

  async function handleSubmit() {
    await removeTeammate.mutateAsync()
    await queryClient.refetchQueries('members')
    showNotification(`${name} has been removed from the team`)
    onClose()
  }

  return {
    onSubmit: form.handleSubmit(handleSubmit),
    isSubmitting: form.formState.isSubmitting,
  }
}
